import { acceptBooleanValue } from '../../field-viewer/shared-normalizers';
export const ecomSubscriptionCheckboxViewer = {
    normalizeLoadedValue: acceptBooleanValue
};

//# sourceMappingURL=definition-viewer.js.map